// このファイルは自動生成されています。手動で編集しないでください。
// 生成元: acomo-backend/openapi.json
// 生成コマンド: npm run generate:descriptions

export const operationDescriptions: Record<string, string> = {
  "approveWorkflowProcess": "指定したワークフロープロセスに対し、承認のアクションを実行する。",
  "approveWorkflowProcessWithNodeId": "指定したワークフロープロセスに対し、承認のアクションを実行する。",
  "connectivityTest": "Slack通知のテストを行う。",
  "convertExpression": "文字列をexpressionに変換します。",
  "createCorsOrigins": "接続を許可するURLを登録します。",
  "createGroup": "グループを1件登録する。",
  "createMyOrganization": "自分の組織を作成する。",
  "createMyOrganizationsTenant": "自分の組織に紐づくテナントを1件登録する。",
  "createOrUpdateAuthConfigsIdentityProvider": "テナントの認証設定にカスタム認証プロバイダーを登録・更新する。",
  "createResetPasswordLink": "パスワードをリセットする。",
  "createRole": "ロールを1件登録する。",
  "createSetting": "設定を1件登録する。",
  "createUser": "ユーザーを1件登録する。",
  "createWorkflowModel": "ワークフローモデルを1件登録する。",
  "deleteAuthConfigsIdentityProvider": "テナントの認証設定から指定したカスタム認証プロバイダーを削除する。",
  "deleteCorsOrigins": "接続を許可するURLを削除します。",
  "deleteMailTemplate": "保存済みメールテンプレートを削除しデフォルトへ戻す。",
  "deleteMyOrganizationsTenant": "自分の組織に紐づくテナントを1件削除する。",
  "deleteMyProcessDataFile": "自身のプロセスデータに紐づいた指定のファイルを削除する",
  "deleteProcessDataFile": "プロセスデータに紐づいた指定のファイルを削除する",
  "deleteWorkflowModel": "ワークフローモデルを1件削除する。",
  "deleteWorkflowProcess": "ワークフロープロセスを1件削除する。",
  "enableMySubscriptions": "自分の組織に紐づくサブスクリプション機能を有効化します。",
  "generateToken": "アクセストークンを発行する。",
  "getAccessToken": "アクセストークンを1件取得する。",
  "getAccount": "自分のアカウント情報を取得する。",
  "getAgentAssistantAvailability": "AI アシスタントが利用可能か",
  "getAuthConfig": "テナントの認証設定情報を取得する。",
  "getChannels": "Slackのチャンネル一覧を取得する。",
  "getClientCredentialsAvailability": "クライアントアクセストークン発行が可能か",
  "getCorsOrigins": "接続を許可するURLを一件取得します。",
  "getCurrentTenant": "自分自身がいまサインインしているテナント情報を取得する。",
  "getCurrentUser": "自分自身のユーザー情報を取得する。",
  "getDiffs": "指定したIDのワークフロープロセスに関連する履歴の差分を取得する。",
  "getGroup": "グループを1件取得する。",
  "getIdentityProvider": "テナントの認証設定から指定したカスタム認証プロバイダーを返却する。",
  "getIdentityProviders": "テナントの認証プロバイダー情報を取得する。",
  "getMyCheckoutUrl": " 顧客がチェックアウトするためのページのURLを発行する。",
  "getMyCustomerPortalUrl": "顧客が各自でサブスクリプションと請求詳細を管理するためのカスタマーポータルのURLを発行する。",
  "getMyDiffs": "指定したIDのワークフロープロセスに関連する履歴の差分を取得する。",
  "getMyModel": "自分自身がアクション可能なモデルの一覧を取得する。",
  "getMyOrganization": "自分の組織情報を取得する。",
  "getMyOrganizationsTenant": "自分の組織に紐づくテナントを1件取得する。",
  "getMyOrganizationsTenantPlanStatus": "自分の組織に紐づくテナント1件のプラン状況を取得する。",
  "getMyProcessDataFileDownloadUrl": "自身のプロセスに紐づいた指定のファイルの一時ダウンロードURLを発行する（有効期限15分）",
  "getMyProcesses": "自分自身がアクション可能、またはアクションしたプロセスを一件取得する。",
  "getMyProcessesWithNodeId": "自分自身がアクション可能、またはアクションしたプロセスを一件取得する。",
  "getMySubscriptions": "自分の組織に紐づくサブスクリプションを全て取得する。",
  "getMySubscriptionsCheckoutUrl": " 自分の組織に紐づくサブスクリプションをチェックアウトするためのページのURLを発行する。",
  "getMySubscriptionsCustomerPortalUrl": "自分の組織に紐づくサブスクリプションと請求詳細を管理するためのカスタマーポータルのURLを発行する。",
  "getMyTenants": "自分のアカウントのメールアドレスを持つユーザーが登録されているテナント情報を全て取得する。",
  "getMyTenantsWithSignInMethod": "自分のアカウントのメールアドレスを持つユーザーが登録されているテナント情報とログイン方法を全て取得する。",
  "getMyTrialSubscription": "利用した無料トライアルのサブスクリプションを取得する",
  "getMyUserAuthInfo": "自分自身のユーザー認証情報を取得する。",
  "getProcessDataFileDownloadUrl": "指定したファイルの一時ダウンロードURLを発行する（有効期限15分）",
  "getProcessWithNodeActions": "自分自身がアクション可能、またはアクションしたプロセス一件をアクション可能なノードとアクションとあわせて取得する。",
  "getProcessWithSpecificNodeActions": "自分自身がアクション可能、またはアクションしたプロセス一件をアクション可能なノードとアクションとあわせて取得する。",
  "getRole": "ロールを1件取得する。",
  "getRootGroup": "ルートグループを取得する。",
  "getSession": "現在サインイン中のセッション情報を取得する。",
  "getSlack": "Slackレコードを1件取得する。",
  "getTenantPlanStatus": "利用した無料トライアルのサブスクリプションを取得する",
  "getUser": "ユーザーを1件取得する。",
  "getUserAuthInfo": "ユーザー認証情報を1件取得する。",
  "getUserLicenseUsage": "ライセンスに基づくユーザー数上限と有効ユーザー数を取得する。",
  "getWorkflowModel": "公開中のワークフローモデルを1件取得する。公開中のモデルがない場合は、モデル定義は空になる。",
  "getWorkflowModelSchemas": "ワークフローモデルのJSON Schemaを返す。typeを指定すると部分取得できる。",
  "getWorkflowModelWithLatestModelHistory": "編集中のワークフローモデルを1件取得する。",
  "getWorkflowProcess": "ワークフロープロセスを1件取得する。",
  "hasAccessToken": "Slackアクセストークンの保存有無をチェックする",
  "installSlackApp": "Slack OAuth 2.0",
  "listAccessToken": "アクセストークンの一覧を取得する。",
  "listApis": "API一覧を取得する。",
  "listCorsOrigins": "接続を許可するURLの一覧を取得します。",
  "listGroups": "グループ一覧を取得する。",
  "listGroupsByUser": "ユーザーが所属するグループ一覧を取得する。",
  "listMailTemplates": "テナントのメールテンプレート一覧を取得する。",
  "listModelHistories": "ワークフローモデル履歴を取得する",
  "listModelWithNodeActions": "自分自身が権限を持つモデル一覧をアクション可能なノードとアクションとあわせて取得する。",
  "listMyModels": "自分自身がアクション可能なモデルの一覧を取得する。",
  "listMyOrganizationsTenants": "自分の組織に紐づくテナント情報を全て取得する。",
  "listMyPlans": "プラン一覧を取得する。",
  "listMyProcesses": "自分自身がアクション可能、またはアクションしたプロセスの一覧を取得する。",
  "listMySubscriptions": "自分のアカウントに紐づくサブスクリプション一覧を取得する。",
  "listMySystemActionPolicies": "自分自身が持つシステム実行ポリシーを一覧で取得する。",
  "listProcessWithNodeActions": "自分自身がアクション可能、またはアクションしたプロセスの一覧をアクション可能なノードとアクションとあわせて取得する。",
  "listRoles": "ロール一覧を取得する。",
  "listRolesByUser": "ユーザーが持つロール一覧を取得する。",
  "listSettings": "テナントに紐づく設定一覧を取得する。",
  "listSystemActionPolicies": "ユーザーが持つシステム実行ポリシーを一覧で取得する。",
  "listUserModelWithNodeActions": "ユーザーが権限を持つモデルの一覧をアクション可能なノードとアクションと併せて取得する。",
  "listUserProcessWithNodeActions": "権限を持つプロセスの一覧をアクション可能なノードとアクションと併せて取得する。",
  "listUsers": "ユーザー一覧を取得する。",
  "listWorkflowModels": "ワークフローモデル一覧を取得する。",
  "listWorkflowProcesses": "ワークフロープロセス一覧を取得する。",
  "listWorkflowProcessHistories": "指定したIDのワークフロープロセスに関連するワークフロープロセス履歴一覧を取得する。",
  "publishWorkflowModel": "ワークフローモデルを1件公開する。",
  "rejectWorkflowProcess": "指定したワークフロープロセスに対し、却下のアクションを実行する。",
  "rejectWorkflowProcessWithNodeId": "指定したワークフロープロセスに対し、却下のアクションを実行する。",
  "restoreWorkflowProcessHistory": "指定した履歴時点の状態をプロセスに復元する",
  "revertWorkflowProcess": "指定したワークフロープロセスに対し、取り戻しのアクションを実行する",
  "revokeAccessToken": "Slackアクセストークンを取り消す",
  "revokeToken": "アクセストークンを取り消す。",
  "saveWorkflowModel": "ワークフローモデルを1件保存する。",
  "saveWorkflowProcess": "指定したワークフロープロセスのプロセスデータを保存する。",
  "saveWorkflowProcessWithNodeId": "指定したワークフロープロセスのプロセスデータを保存する。",
  "sendAgentMessage": "AI エージェントへメッセージを送信し、Cursor SDK の SDKMessage を SSE（text/event-stream）でストリームする。会話状態は永続されない。",
  "sendInitializeMyPasswordEmail": "自身のパスワードログインアカウントを作成し、初期パスワードをメールで送信する。",
  "sendInitializePasswordEmail": "パスワードログインを設定していないユーザーのアカウントを作成し、初期パスワードをメールで送信する。",
  "sendUserInvitationEmail": "招待メールを再送する。",
  "signInWithEmailAndPassword": "メールアドレスとパスワードでサインインする。",
  "signOut": "サインアウトする（現在のセッションを破棄する）。",
  "startWorkflowProcess": "指定したワークフローモデルのプロセスを新規に開始する。",
  "submitWorkflowProcess": "指定したワークフロープロセスに対し、提出のアクションを実行する。",
  "submitWorkflowProcessWithNodeId": "指定したワークフロープロセスに対し、提出のアクションを実行する。",
  "updateAccessToken": "アクセストークンの名前や説明を更新する。",
  "updateCorsOrigins": "接続を許可するURLを更新します。",
  "updateGroup": "グループを1件更新する。",
  "updateMailTemplate": "メールテンプレートを保存する。",
  "updateMyOrganization": "自分の組織を更新する。",
  "updateMyOrganizationsTenant": "自分の組織に紐づくテナントを1件更新する。",
  "updateRole": "ロールを1件更新する。",
  "updateSettings": "設定を1件更新する。",
  "updateSlack": "Slackレコードを1件更新する。",
  "updateUser": "ユーザーを1件更新する。",
  "updateWorkflowProcess": "ワークフロープロセスを1件保存する。",
  "uploadMyProcessDataFile": "自身のプロセスデータに紐づいたファイルをアップロードする",
  "uploadProcessDataFile": "プロセスデータに紐づいたファイルをアップロードする",
  "validateExpression": "expressionが正しいかを返します。",
  "validateWorkflowModelSchema": "ワークフローモデルの definition / dataSchema / policy を JSON Schema に対してバリデーションする。モデルの公開前に使用する。",
};
